import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
import { customColorNames, customColorVariants, customFontSizes } from "./design-tokens";

// Extend tailwind-merge to understand our custom color palette, font sizes, and shadows
// This configuration is automatically synced with tailwind.config.ts via design-tokens.ts
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: ["xs", "sm", "base", "lg", "xl", "2xl", "3xl", "4xl", "5xl", "6xl", "7xl", "8xl", "9xl"] },
        { text: customFontSizes },
      ],
      "text-color": [{ text: customColorNames }, { text: customColorVariants }],
      shadow: [{ shadow: ["outline-2"] }],
    },
  },
});

// This utility function merges class names and handles conditional classes
// It uses clsx for conditional class names and tailwind-merge to handle conflicts
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
